import { render, staticRenderFns } from "./columnHomepage.vue?vue&type=template&id=09c2ab54&scoped=true"
import script from "./columnHomepage.vue?vue&type=script&lang=js"
export * from "./columnHomepage.vue?vue&type=script&lang=js"
import style0 from "./columnHomepage.vue?vue&type=style&index=0&id=09c2ab54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c2ab54",
  null
  
)

export default component.exports